import React__default from 'react';
import PropTypes from 'prop-types';
import Button from '../../Button/Button.js';
import { isNullish } from '../../../../utils/validation.js';
import ButtonGroup from '../../ButtonGroup/index.js';

var SliderPresets = function SliderPresets(_ref) {
  var data = _ref.data,
    _onClick = _ref.onClick,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? undefined : _ref$testId;
  var validData = data.filter(function (_ref2) {
    var name = _ref2.name,
      value = _ref2.value;
    return !isNullish(name) && !isNullish(value);
  });
  return React__default.createElement(ButtonGroup, {
    testId: testId
  }, validData.map(function (_ref3) {
    var name = _ref3.name,
      value = _ref3.value;
    return React__default.createElement(Button, {
      isDisabled: isDisabled,
      variant: "secondary",
      size: "small",
      key: "slider-preset-".concat(name, "-").concat(value),
      onClick: function onClick(e) {
        return _onClick(e, value);
      }
    }, name);
  }));
};
SliderPresets.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]).isRequired
  })).isRequired,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  testId: PropTypes.string
};

export { SliderPresets };
//# sourceMappingURL=SliderPresets.js.map
